module.exports = __webpack_public_path__ + "scripts/brand-icons.woff2?9f4ce3dc";


//////////////////
// WEBPACK FOOTER
// ./semantic/dist/themes/default/assets/fonts/brand-icons.woff2
// module id = 218
// module chunks = 1